import { render, staticRenderFns } from "./RelatedInfo.vue?vue&type=template&id=2e814b7d&"
import script from "./RelatedInfo.vue?vue&type=script&lang=js&"
export * from "./RelatedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports